import {useState} from "react";

import Loading from "@/components/Loading";
import ClinicSearchForm from "@/components/clinics/ClinicSearchForm";


export default function ClinicsPage() {
  const [loading, setLoading] = useState(false);

  if (loading) return <Loading/>;

  return (
    <div className="main">
      <div className="container-fluid -countriesList">
        <div className="container">
          <div className="row">
            <h1>Covid Testing Locations Near You</h1>
            <div className="col-12 -messageBox -info">
              <div className="-messageContainer">
                Please select a region to see the full list of clinics
              </div>
            </div>
          </div>
        </div>
        <ClinicSearchForm/>
      </div>
    </div>
  );
}
